var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card border-0 h-md-100",attrs:{"data-bs-theme":"light"}},[_c('img',{attrs:{"src":"https://xysy-saas.oss-cn-hangzhou.aliyuncs.com/lianXiangHui/dashboard/banner2.png","width":"100%"},on:{"click":_vm.toolsClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }